export enum NetworkApplicationStatus {
  DISABLED = 'DISABLED',
  REMOVED = 'REMOVED',
  REJECTED = 'REJECTED',
  PROCESSING = 'PROCESSING',
  INCOMPLETE = 'INCOMPLETE',
  MISSING_DOCUMENTS = 'MISSING_DOCUMENTS',
  APPROVED = 'APPROVED',
}
